export const ARTICLE_DATA = {
  'getting-started': {
    titles: [
      'Introduction to Spatial Grid',
      'Understanding Spatial Grid Use Cases',
      'Platform Architecture and Capabilities',
      'Device & Hardware Support',
      'Creating & Managing Experiences',
      'User Roles, Access and Governance',
      'Analytics, Insights and Reporting',
      'Deployment, Integration and IT Readiness',
      'Enterprise Enablement and Support',
    ],
    tocData: {
      0: [
        'What is Spatial Grid',
        'Platform Philosophy',
        'Core Capabilities',
        'Enterprise Value',
      ],
      1: [
        'Understanding Spatial Grid Use Cases',
        'Immersive Training & SOP Enablement',
        'Simulation & Operational Readiness',
        'Digital Twins & Spatial Visualization',
        'Interactive Marketing & Engagement',
        'Education & Research',
      ],
      2: [
        'Modular Architecture',
        'Spatial Engines & Interaction Systems',
        'AI Plug-ins & Intelligence Layer',
        'Analytics & Data Layer',
        'Scalability & Performance',
      ],
      3: [
        'Supported Device Types',
        'Device Abstraction Layer',
        'Develop Once, Deploy Anywhere',
        'Hardware Flexibility & Future Readiness',
      ],
      4: [
        'Experience Design Workflow',
        'Content Structuring & Scene Logic',
        'Collaboration Across Teams',
        'Updates & Lifecycle Management',
      ],
      5: [
        'Enterprise User Management',
        'Roles & Permissions',
        'Access Control & Security',
        'Governance Models',
      ],
      6: [
        'Interaction & Engagement Metrics',
        'Performance & Effectiveness Measurement',
        'Reporting for Stakeholders',
        'Data-Driven Optimization',
      ],
      7: [
        'Deployment Models',
        'Integration with Enterprise Systems',
        'IT & Security Alignment',
        'Operational Readiness',
      ],
      8: [
        'Onboarding & Training',
        'Consulting & Co-Creation',
        'Support & Maintenance',
        'Scaling with Confidence',
      ],
    },
    basePath: '/help-center/getting-started-articles',
    categoryPath: '/help-center/getting-started',
    categoryName: 'Getting Started',
  },
  alliances: {
    titles: [
      'SpatialGrid Alliances',
      'Type of Alliances',
      'Alliances Objectives',
      'Benefits',
    ],

    tocData: {
      0: ['SpatialGrid Alliances'],
      1: ['Type of Alliances'],
      2: ['Alliances Objectives'],
      3: ['Benefits'],
    },

    basePath: '/help-center/alliances-articles',
    categoryPath: '/help-center/alliances',
    categoryName: 'Alliances',
  },
  licensing: {
    titles: [
      'Spatial Grid Licensing & Subscription Programs',
      'Licensing Model Overview',
      'Single User Monthly Subscription',
      'Single User Annual Subscription',
      'Multi User Annual Subscription',
      'Three-Year Enterprise Subscription Program',
      'Designed for Enterprise Adoption',
      'Get in Touch',
    ],

    tocData: {
      0: ['Spatial Grid Licensing & Subscription Programs'],
      1: ['Licensing Model Overview'],
      2: ['Single User Monthly Subscription'],
      3: ['Single User Annual Subscription'],
      4: ['Multi User Annual Subscription'],
      5: ['Three-Year Enterprise Subscription Program'],
      6: ['Designed for Enterprise Adoption'],
      7: ['Get in Touch'],
    },

    basePath: '/help-center/licensing-articles',
    categoryPath: '/help-center/licensing',
    categoryName: 'Licensing',
  },
  partnership: {
    titles: [
      'Spatial Grid Partner Ecosystem',
      'Go-To-Market (GTM) Partnership Aligned to Industry Verticals',
      'Flexible Commercial Models: License Sales & Consulting Engagements',
      'Partnership Agreements Built on Global Best Practices',
      'Why Partner with Spatial Grid',
      'Partner With Us',
    ],
    tocData: {
      0: ['Spatial Grid Partner Ecosystem'],
      1: ['Go-To-Market (GTM) Partnership Aligned to Industry Verticals'],
      2: ['Flexible Commercial Models: License Sales & Consulting Engagements'],
      3: ['Partnership Agreements Built on Global Best Practices'],
      4: ['Why Partner with Spatial Grid'],
      5: ['Partner With Us'],
    },
    basePath: '/help-center/partnership-articles',
    categoryPath: '/help-center/partnership',
    categoryName: 'Partnership',
  },
  usingspatialgrid: {
    titles: [
      'Spatial Grid Dashboard',
      'Projects & Workspaces',
      'Grid Editor',
      'Prompt Bar & Intelligent Controls',
      'Asset Library & Reusable Components',
      'Teams, Roles & Collaboration',
      'Tutorials, Guides & In-Platform Learning',
      'Analytics & Experience Insights',
      'Notifications & Activity Monitoring',
    ],
    tocData: {
      0: ['Overview', 'Key Sections of the Dashboard'],
      1: [
        'Project Overview',
        'Common Project Types',
        'Workspaces',
        'Organizing at Enterprise Scale',
        'Governance & Control',
      ],
      2: [
        'Editor Overview',
        'Design, Preview & Code Functionality',
        'Scene Creation & Layout',
        'Asset Panel',
        'Components',
        'Transform Controls',
        'Add Assets',
        'Help',
        'Interaction & Behavior Configuration',
        'Publish & Review',
      ],
      3: [
        'Prompt Bar Overview',
        'AI-Assisted Actions',
        'Business User Enablement',
      ],
      4: [
        'Asset Library Overview',
        'Reuse & Consistency',
        'Versioning & Updates',
        'Enterprise Benefits',
      ],
      5: [
        'Team Structure',
        'Role-Based Access',
        'Review & Approval Workflows',
        'Multi-Team Coordination',
      ],
      6: [
        'Guided Tutorials',
        'Contextual Help',
        'Role-Based Learning',
        'Faster Adoption',
      ],
      7: ['Analytics Overview', 'Key Metrics'],
      8: [
        'Notification Types',
        'Activity Feeds',
        'Enterprise Alignment',
        'Operational Awareness',
      ],
    },
    basePath: '/help-center/using-spatialgrid-articles',
    categoryPath: '/help-center/using-spatialgrid',
    categoryName: 'Using-Spatialgrid',
  },
  practicetroubleshooting: {
    titles: [
      'Best Practices and Troubleshooting',
      'Best Practices',
      'Pitfalls to Avoid',
    ],
    tocData: {
      0: ['Best Practices and Troubleshooting'],
      1: ['Best Practices'],
      2: ['Pitfalls to Avoid'],
    },
    basePath: '/help-center/practices-troubleshooting-articles',
    categoryPath: '/help-center/practices-troubleshooting',
    categoryName: 'Practices Troubleshooting',
  },
};
